export default __webpack_public_path__ + "static/media/DroneShot.b465eb2e.mp4";